import React from 'react'
import GeneralServices from '../../app/service/generalServices'
import { Button } from 'primereact/button'
import TooltipButton from '../tooltipButton'
import * as popUp from '../toastr'
import QuantidadeParcelasComponent from '../contasAPagar/quantidadeParcelasComponent'
import SelectMenu from '../selectMenu'
import ProductService from '../../app/service/productService'
import FormGroup from '../form-group'
import ConstantsUtil from '../../context/constantsUtil'
import { InputNumber } from 'primereact/inputnumber'
import BuyProductService from '../../app/service/buyProductService'
import HandleErrorService from '../../app/service/handleErrorService'
import NotaFiscalDTO from '../../dominio/nf/NotaFiscalDTO'
import { Dialog } from 'primereact/dialog'
import NFService from '../../app/service/estoque/NFService'

class DadosNfseComponent extends React.Component {

    constructor(){
        super()
        this.quantidadeParcelasComponentRef = React.createRef()
    }

    state = {
        numeroDocumento: '',

        complementoHistorico: '',

        valorTotalNF: null,
        inputValorTotalNFErrorClass: '',

        valorDescontoPorDevolucao: null,
        
        selectAcrescimoDesconto: '',
        
        valorAcrescimoDesconto: null,
        inputValorAcrescimoDescontoErrorClass: '',

        qtdParcelas: '',
        inputParcelasErrorClass: '',
        errorParcelasMessage: 'Informe a quantidade de Parcelas',

        pagamentoList: [],

        didUpdated: false,
        forceProductListUpdate: false,

    }

    componentDidMount(){
        this.setStates()
    }
    
    setStates = () => {
        // console.log("this.props.NFToValidate.transactions ", this.props.NFToValidate.transactions)
        this.resetView()
        // this.resetData()
        // console.log("this.props: ", this.props)
        this.trataDadosProvisao()

    }

    resetView = () => {
        this.setState({inputValorTotalNFErrorClass: ''})

        this.setState({inputValorAcrescimoDescontoErrorClass: ''})

        this.setState({inputParcelasErrorClass: ''})

        this.state.pagamentoList.forEach(pagamentoItem => {
            pagamentoItem.inputDateErrorClass = ''
            pagamentoItem.inputValorErrorClass = ''
        })

    }

    trataDadosProvisao = () => {
        // console.log("NFToValidate: ", this.props.NFToValidate)
        let provisao = this.props.NFToValidate && this.props.NFToValidate.provisao
        if(provisao){
            provisao.parcelaProvisaoList.forEach(parcela => {
                parcela.dataView = GeneralServices.convertBrStringToJsDate(parcela.data)
            })
        }
    }

    handleSelectAcrescimoDescontoChange = (event) => {
        this.handleChange(event)
        this.setState({valorAcrescimoDesconto: null})
    }

    handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleNumeroChange = async (event) => {
        let value = event.target.value
        const name = event.target.name

        if(value && value < 0){
            value*=-1
        }

        this.setState({[name]: value})
        
    }

    handleValorChange = (event) => {
        // console.log("event: ", event)
        let value = event.value
        if(value === 0){
            value = null
        }
        const name = event.target.name
        this.setState({ [name]: value })
    }    

    checkData = () => {

        // console.log("checkData dadosNFComponent transactions: ", this.state.transactions)
        
        this.resetView()

        var check = true

        if(!this.state.valorTotalNF && !this.props.insideValidateNFDialog && !this.props.emprestimo){
            this.setState({inputValorTotalNFErrorClass: ConstantsUtil.primereactInputErrorClass})
            check = false
        }

        if(this.state.selectAcrescimoDesconto && !this.state.valorAcrescimoDesconto) {
            this.setState({inputValorAcrescimoDescontoErrorClass: ConstantsUtil.primereactInputErrorClass})
            check = false
        }

        let checkSomatorio = true

        let checkQuantidadeParcelasComponent = {checkGeral: true, apenasCheckSomatorioFalhou: false}
        if(!this.props.isNFSaida && !this.props.emprestimo){
            checkQuantidadeParcelasComponent = this.quantidadeParcelasComponentRef.current.checkData()
        }

        let resultCheck = check && checkSomatorio && checkQuantidadeParcelasComponent.checkGeral

        let apenasCheckSomatorioFalhou = !resultCheck && (check && checkQuantidadeParcelasComponent.apenasCheckSomatorioFalhou)

        if(!resultCheck && !apenasCheckSomatorioFalhou){
            popUp.warningPopUp("Preencha todas as informações.")
        }
        
        return resultCheck
        // return false
    }

    getColMdClasses = () => {
        if(this.props.insideValidateNFDialog){
            return {
                dataEntrada: 'col-md-6',
                horarioEntrada: 'col-md-6',
            }
        }
        else{
            return {
                dataEntrada: 'col-md-2',
                horarioEntrada: 'col-md-2',
            }
        }
    }

    getValorTotal = () => {
        if(this.props.insideValidateNFDialog){
            return this.props.NFToValidate ? this.props.NFToValidate.valorTotal : null
        }
        return this.state.valorTotalNF
    }

    getRealValorAcrescimoDesconto = () => {
        if(this.state.selectAcrescimoDesconto) {
            if(this.state.selectAcrescimoDesconto === ConstantsUtil.nfDescontoValue) {
                return this.state.valorAcrescimoDesconto*-1
            }
            return this.state.valorAcrescimoDesconto
        }
        return 0
    }

    getPagamentoList = () => {
        return this.quantidadeParcelasComponentRef.current.state.pagamentoList
    }


    render() {

        const renderNumeroAndComplementoHistorico = () => {
            if(!this.props.insideValidateNFDialog) {
                return (
                    <>
                    <div className="col-md-2">
                        <label htmlFor="date">N° do Documento (Opcional)</label>
                        <input
                            type="number"
                            className={"form-control " }
                            value = {this.state.numeroDocumento}
                            name="numeroDocumento"
                            onChange={this.handleNumeroChange}
                            id="nomeTipoDeRecebimento"
                            // disabled={this.props.provisao && this.props.provisao.notaFiscal}
                        />
                    </div>

                    <div className="col-md-3">
                    <label htmlFor="icon">Complemento de Histórico (Opcional)</label>
                        <input
                            type="text"
                            className={"form-control "}
                            value = {this.state.complementoHistorico}
                            name="complementoHistorico"
                            onChange={this.handleChange}
                        />
                    </div>
                    </>
                )
            }            
        }

        const renderValorTotalNF = () => {
            if(!this.props.insideValidateNFDialog && !this.props.emprestimo) {
                return (
                    <>
                    <div className="col-md-12">

                    <div className="row">
                        <div className="col-md-2">
                            <label>Valor Total</label>
                        </div>
                        {/* <div className="col-md-2">
                        </div>
                        {renderLabelValorAcrescimoDesconto()} */}
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            <InputNumber 
                                ref={this.inputValorRef}
                                className={this.state.inputValorTotalNFErrorClass}
                                name="valorTotalNF"
                                value={this.state.valorTotalNF}
                                onValueChange={this.handleValorChange}
                                // onKeyDown={this.handleKeyPress}
                                mode="decimal" locale="pt-BR" minFractionDigits={2}
                                // disabled={this.props.provisao && this.props.provisao.notaFiscal}
                            />
                        </div>
                        {renderAcrescimoDescontoComponent()}
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                        <small id="valorError" className="p-error">{this.state.inputValorTotalNFErrorClass ? 'Informe o valor' : ''}</small>
                        </div>
                    </div>  
                    </div>
                    <br />
                    </>
                )
            }
        }

        const renderAcrescimoDescontoComponent = () => {
            if(!this.props.isNFSaida)
            return (
                <>
                    <div className='col-md-1'>
                    <label>Acréscimo/Desconto?</label>
                    <SelectMenu
                        id="selectAcrescimoDesconto"
                        className={"form-control " }
                        // ref={this.tipoDeLancamentoInputRef}
                        name="selectAcrescimoDesconto"
                        list={ConstantsUtil.acrescimoDescontoSelectList(false)}
                        value={this.state.selectAcrescimoDesconto}
                        onChange={this.handleSelectAcrescimoDescontoChange}
                        // disabled={this.props.fromOFX}
                    /> 
                    </div>
                    {renderValorAcrescimoDesconto()}                
            </>
            )
        }

        const renderValor = (label, valor) => {
            return(
                <div className='col-md-1'>
                    <label>{label}</label>
                    <InputNumber 
                        // ref={this.inputValorRef}
                        className={this.state.inputValorTotalNFErrorClass}
                        // name="valorTotalNF"
                        value={valor}
                        // onValueChange={this.handleValorChange}
                        // onKeyDown={this.handleKeyPress}
                        mode="decimal" locale="pt-BR" minFractionDigits={2}
                        disabled
                    />                            
                </div>
            )
        }

        const renderValorTotalNFInfo = () => {
            if(this.props.insideValidateNFDialog) {
                return (
                    <>
                        <div className='col-md-12'>
                        <div className='row'>

                        {renderValor("Valor Bruto", this.props.NFToValidate.valorBruto)}
                        {renderValor("Valor PIS", this.props.NFToValidate.valorPis)}
                        {renderValor("Valor COFINS", this.props.NFToValidate.valorCofins)}
                        {renderValor("Valor INSS", this.props.NFToValidate.valorInss)}
                        {renderValor("Valor IR", this.props.NFToValidate.valorIr)}
                        {renderValor("Valor CSLL", this.props.NFToValidate.valorCsll)}
                        {renderValor("Valor ISS", this.props.NFToValidate.valorIss)}
                        {renderValor("Valor Líquido", this.props.NFToValidate.valorLiquido)}

                        {renderAcrescimoDescontoComponent()}
                        </div>
                        </div>
                    </>
                )
            }
        }

        const renderValorAcrescimoDesconto = () => {
            if(this.state.selectAcrescimoDesconto) {
                return (
                    <>
                    <div
                        className='col-md-1'
                        style={{marginLeft: '1rem'}}
                    >
                    <label>&nbsp;</label>
                    <InputNumber 
                        className={this.state.inputValorAcrescimoDescontoErrorClass}
                        name="valorAcrescimoDesconto"
                        value={this.state.valorAcrescimoDesconto}
                        onValueChange={this.handleNumeroChange}
                        // onKeyDown={this.handleKeyPress}
                        mode="decimal" locale="pt-BR" minFractionDigits={2} maxFractionDigits={2}
                        placeholder='Valor'
                    />
                    <div className="row">
                        <div className="col-md-12">
                        <small id="valorError" className="p-error">{this.state.inputValorAcrescimoDescontoErrorClass ? `${ConstantsUtil.informeValorErrorMenssage}`: ""}</small>
                        </div>
                    </div>
                    </div>

                    </>
                )
            }
        }

        const renderPagamentoLabel = () => {
            if(this.props.insideValidateNFDialog){
                return (
                    <div className='row'>
                    <br />
                    <div className='col-md-2'>
                        <h5>Pagamento</h5>
                    </div>
                    </div>
                )
            }
        }

        // const renderLabelValorAcrescimoDesconto = () => {
        //     if(this.state.selectAcrescimoDesconto){
        //         return (
        //             <>
        //                 <div className='col-md-2'>
        //                     <label>Valor do Acréscimo/Desconto</label>
        //                 </div>
        //             </>
        //         )
        //     }
        // }

        // const renderDemaisLabels = () => {
        //     return (
        //         <>
        //             {renderLabelValorAcrescimoDesconto()}
        //         </>                
        //     )
        // }

        const renderQuantidadeParcelasComponent = () => {
            // if(!this.props.isNFSaida)
            return (
                <QuantidadeParcelasComponent
                    ref={this.quantidadeParcelasComponentRef}
                    provisao={this.props.NFToValidate ? this.props.NFToValidate.provisao : null}
                    NF={this.props.NFToValidate ? this.props.NFToValidate : null}
                    // valorTotalProvisao={this.getValorTotal()}
                    valorTotalProvisao={this.props.NFToValidate.valorLiquido}
                    valorAcrescimoDesconto={this.getRealValorAcrescimoDesconto()}
                    insideDialog={this.props.insideValidateNFDialog}
                    // qtdParcelas={1}
                />
            )
        }

        const renderPagamento = () => {
            if(this.props.insideValidateNFDialog){
                return renderQuantidadeParcelasComponent()
            }
            return (
                <div className='col-md-12'>
                    {renderQuantidadeParcelasComponent()}
                </div>
            )

        }

        return (

            <>
                <>
                <div className='col-md-12'> 
                    
                
                <div className='row'>

                    {renderNumeroAndComplementoHistorico()}

                </div>
                </div>

                <br/>
                {renderValorTotalNF()}
                {renderPagamentoLabel()}

                {renderValorTotalNFInfo()}

                {renderPagamento()}

                </>
            </>
      
        )
    }


}

export default DadosNfseComponent